import { axios } from "~/plugins/request"

export const state = () => {
    return {}
}
export const mutations = {}
export const actions = {
    findInit({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.get(`university/findAllUniversityTagAndDicAndPro`)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    findByList({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`university/findByList`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    findById({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`university/findById`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    findUniFacultySpe({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`university/findUniFacultySpe`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    findEnrollmentGuideById({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`university/findEnrollmentGuideById`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    enrollmentGuideList({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`university/findEnrollmentGuideById`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    artEnrollmentGuideList({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`university/findArtEnrollmentGuideById`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    saveStudentUniversity({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`university/saveStudentUniversity`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    saveStudentSpecility({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`university/saveStudentSpecility`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    findHistoryData({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`university/findHistoryData`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    updateUniversityName({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios.post(`university/updateName`, params)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
}
